<template>
  <div>
    <el-row :gutter="20" class="top-block">
      <Breadcrumb :route="this.$route"></Breadcrumb>
    </el-row>

      <!-------------------------------------------------------------------->
      <!-- action -->
      <!-------------------------------------------------------------------->
    <el-row class="ml-20 mr-20">
      <el-col :xs="12" :sm="12" :lg="12">
        <el-button icon="el-icon-search" circle type="warning" @click="drawer = true"></el-button>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="12">
        <el-button type="primary" @click.prevent="createTodo" style="float: right">新增 <i class="el-icon-circle-plus-outline"></i>
        </el-button>
      </el-col>
    </el-row>
    <el-row >

     

      <!-------------------------------------------------------------------->
      <!-- table -->
      <!-------------------------------------------------------------------->
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
        <el-main>
          <el-table :fit="true" :data="tableData" empty-text="無資料" stripe header-row-class-name="headerStyle">
            <el-table-column prop="title" label="標題" width="130">
              <template slot-scope="scope">
                <router-link :to="`${scope.row.todoUrl}${scope.row.id}`">{{scope.row.title }}
                </router-link>
                <p>{{scope.row.startDate | fmtDate}}</p>
              </template>
            </el-table-column>
            
            <el-table-column label="狀態" width="100">
              <template slot-scope="scope">
                
                <el-tag v-if="scope.row.status === 'reject'" type="danger">{{ scope.row.status | fmtSignResult }}</el-tag>
                <el-tag v-else>{{ scope.row.status | fmtSignResult }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="" type="expand" width="30">
              <template slot-scope="scope">
                <el-form label-position="left" inline class="demo-table-expand" v-if="scope.row.status === 'close'">
                  <ol>
                    <li v-for="f in scope.row.relatedJobs" :key="f.id" class="mt-10">
                      {{f.updatedAt | fmtDateTime}}, {{f.signerObj.username}}, {{f.notes}}
                    </li>
                  </ol>
                </el-form>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-popconfirm
                    class="ml-10 popconfirm-bg"
                    title="提醒，修改已簽核完成的申請單，需要重新送簽"
                    confirm-button-text="確定"
                    cancel-button-text="取消"
                    icon="el-iconf-info"
                    icon-color="red"
                    @confirm="handleReEdit(scope.row.id)"
                >
                  <el-button class="mr-10" v-if="scope.row.status === 'close'" type="info" slot="reference" icon="el-icon-edit" circle ></el-button>
                </el-popconfirm>

                <el-popconfirm
                    class="ml-10 popconfirm-bg"
                    title="確定刪除此筆資料嗎?"
                    confirm-button-text="確定"
                    cancel-button-text="取消刪除"
                    icon="el-iconf-info"
                    icon-color="red"
                    @confirm="handleDelete(scope.row.id)"
                >
                <el-button v-if="scope.row.status === 'draft'" type="danger" icon="el-icon-delete" circle slot="reference"></el-button>
                  
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>

          <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="total"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>

        </el-main>
      </el-col>

      <!-------------------------------------------------------------------->
      <!-- dialog -->
      <!-------------------------------------------------------------------->
      <el-dialog title="日誌資訊"
                 :visible.sync="dialogFormVisible"
                 :width="dw"
                 @close="closeDialog">
        <el-form :model="form"
                 :rules="rules"
                 ref="dataForm"
                 label-width="100px">

          <el-row>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="標題" prop="title">
                <el-input v-model="form.title" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="預計開始日" prop="startDate">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.startDate"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="預計結束日" prop="endDate">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.endDate"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveData('dataForm')">確 定</el-button>
        </div>
      </el-dialog>



      <!-------------------------------------------------------------------->
      <!-- query -->
      <!-------------------------------------------------------------------->
      <el-drawer
        size="70%"
        title="搜尋"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">
        <div>
          <el-select v-model="queryField" placeholder="選擇搜尋條件" class="pr-10 pl-10" style="display: inline-block;">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="keyword" placeholder="選擇狀態" class="pr-10 pl-10 mt-10" style="display: inline-block;">
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-button type="primary" @click.prevent="search" class="ml-10 mt-10">查詢</el-button>
        <el-button type="normal" @click.prevent="clearQuery" class="ml-10 mt-10">清除條件</el-button>
        </div>
    
      </el-drawer>


    </el-row>
  </div>

</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import dayjs from "dayjs"
import axios from "axios";

export default {
  name: "TodoMaintain",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }

    return {
      drawer: false,
      direction: 'ltr',
      dw: '60%',
      tableData: [],
      options: [{
        value: 'status',
        label: '依狀態'
      }],
      statusOptions: [
        {　value: 'draft', label: '草稿'},
        {　value: 'review', label: '等待簽核中'},
        {　value: 'reject', label: '退回'},
        {　value: 'close', label: '完成'}
      ],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      form: {
        title: '',
        startDate: '',
        endDate: '',
        status: 'draft',
        userId: '',
        todoType: '',
        preCheckItem: '',
        visitRoute: ''
      },
      rules: {
        title: [{required: true, validator: checkName, trigger: 'change'}],
        startDate: [{required: true, validator: checkName, trigger: 'change'}],
        endDate: [{required: true, validator: checkName, trigger: 'change'}]
      }
    }
  },
  computed: {
    ...mapState('login', ['userInfo'])
  },
  methods: {
    handleClose(){
      this.drawer = false
    },
    openSearch(){
      this.drawer = true
    },
    search() {
       this.drawer = false
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.loadData()
    },
    clearQuery() {
      this.drawer = false
      this.keyword = ''
      this.queryField = ''
      this.loadData()
    },

    /** data crud **/
    async loadData() {

      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        queryField: this.queryField,
        keyword: this.keyword
      }
      try {
        let result = await this.$store.dispatch('todo/getAllMytodos', data);
        this.tableData = result.data.records
        this.total = result.data.total
      } catch (e) {
        this.tableData = []
        this.total = 0
        this.showResult('error', e.message)
      }

    },
    createTodo(){
      this.form.title = "工作日報"
      this.form.startDate = new Date()
      this.request.post("/todo", this.form).then(res => {
        if (res.code === '200') {
          this.$router.push(res.data.todoUrl + res.data.id)
        }
      })
    },

    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('this.form:', this.form)
        if (valid) {
          try {
            await this.$store.dispatch('todo/saveMytodo', this.form)

            this.showResult('success', '資料新增成功.')

            await this.loadData()
            this.dialogFormVisible = false

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form.id = null
    },
    handleEdit(rowData) {
      this.dialogFormVisible = true
      this.form = rowData
    },
    async handleDelete(id) {
      try {
        await this.$store.dispatch('todo/deleteMytodo', id)
        this.showResult('success', '資料刪除成功.')

        await this.loadData()
        this.dialogFormVisible = false

      } catch (e) {
        this.showResult('error', '資料刪除失敗.')
      }
    },

    closeDialog() {
      this.$refs['dataForm'].resetFields()
      this.loadData()
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "60%"
      }
    },
    formDefault() {
      this.form.userId = this.userInfo.id
      
    },
    handleReEdit(id){
      this.request.post(`/todo/draft/${id}`).then(res => {
        if (res.code === '200') {
          this.$router.push(res.data.todoUrl + res.data.id)
        }
      })
    }

  },
  mounted() {
    this.loadData()
    this.formDefault()
    this.setDialogWidth()
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}

main >>> .el-card__body {
  padding: 0px;
}

main >>> .el-table {
  padding: 0 10px;
}

.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 8px;
}

.taskMain >>> .el-card__body {
  padding: 0;
}
.el-table {
  padding: 0;
}

</style>
